module.exports = {"id":"241463","name":"Dani Raba","rating":"72","photo":"./data/images/photos/3/241463.png","club":{"name":"Villarreal CF","logo":"./data/images/clubs/VillarrealCF.png"},"positions":["MD","MG","MC","BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DaniRaba0.json
// module id = 916
// module chunks = 0